﻿import { useAssessment } from "../hooks/useAssessment";
import { ASSESSMENT_QUESTIONS } from "../data/questions";
import { OccupationSearch } from "./OccupationSearch";
import { Level1Overview } from "./Level1Overview";
import { Questionnaire } from "./Questionnaire";
import { ReportView } from "./ReportView";

export function AssessmentFlow() {
  const { state, selectOccupation, startQuestionnaire, submitAnswers, fetchAICompare, reset } =
    useAssessment();

  if (state.level === 1 && !state.occupationDetail) {
    return <OccupationSearch onSelect={selectOccupation} />;
  }

  if (state.level === 1 && state.occupationDetail) {
    return (
      <Level1Overview
        detail={state.occupationDetail}
        onStartQuestionnaire={startQuestionnaire}
      />
    );
  }

  if (state.level === 2) {
    return (
      <Questionnaire
        questions={ASSESSMENT_QUESTIONS}
        onSubmit={submitAnswers}
      />
    );
  }

  if (state.level === 3 && state.result) {
    return (
      <ReportView
        result={state.result}
        detail={state.occupationDetail!}
        aiCompare={state.aiCompare}
        aiLoading={state.aiLoading}
        onFetchAICompare={fetchAICompare}
        onRetake={reset}
      />
    );
  }

  return null;
}
